import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import TopicSearchHistory from 'components/topic/TopicSearchHistory';
import { composeNewSearch } from 'components/topic/topicHelpers';

const SidebarThemeList = () => {
  const classes = useStyles();

  return (
    <>
      <Grid container direction="row" alignItems="center" justify="space-between">
        <Grid item className={classes.alignFlexItemCenter}>
          <b>My Themes</b>
        </Grid>
        <Grid item className={classes.alignFlexItemCenter}>
          <Tooltip title="Compose New Theme">
            <IconButton onClick={e => composeNewSearch(e)} className={classes.composeNewBtn}>
              <AddCircleOutlineIcon />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
      <div>
        <TopicSearchHistory />
      </div>
    </>
  );
};

export default SidebarThemeList;

const useStyles = makeStyles(() => ({
  alignFlexItemCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  composeNewBtn: {
    padding: '4px 12px',
    borderRadius: '8px',
  },
}));
